import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import styled from 'styled-components';
import useUrlParams from '../../hooks/useUrlParams';
// import { PieWrapper } from './ChartCountry';

ChartJS.register(ArcElement, Tooltip, Legend);

const colorSets = {
  device: ['#A803BF', '#700E7F', '#530F5F', '#D455E5', '#E1D5FF', '#8B929A'],
  os: ['#9765CC', '#6E34AA', '#989EFF', '#FFCC58', '#CCA265', '#8B929A']
};

const colorSetsMePage = {
  device: ['#276AD4', '#0C3F90', '#001E4C', '#68A2FF', '#BFD8FF', '#8B929A'],
  os: ['#CF8500', '#A66A00', '#FFE7BC', '#F8A40F', '#FFC866', '#BDC6CF']
};

const colorSetsGenQrCode = {
  device: ['#651FFF', '#512DA8', '#673AB7', '#7E57C2', '#B39DDB', '#311B92'],
  os: ['#FFA726', '#d17e01', '#FFE7BC', '#f69b13', '#FFC866', '#BDC6CF']
};

const DeviceChart = ({ data, color, title }) => {
  const { isMePage, isGenQrCodePage } = useUrlParams();
  const options = {
    // responsive: false,
    maintainAspectRatio: true,
    responsive: true,
    layout: {},

    plugins: {
      legend: {
        display: true,
        position: 'right',
        align: 'medium',
        labels: {
          fontColor: '#3E4957',
          fontSize: 16,
          boxWidth: 13,
          boxHeight: 13,
          font: {
            weight: '400',
            size: 16
          }
        },
        title: {
          display: true,
          text: title,
          font: {
            size: 18,
            weight: '400'
          }
        }
      }
    }
  };

  const legendMinWidthPlugin = {
    id: 'legendMinWidth',
    beforeLayout(chart) {
      const legend = chart.legend;
      if (!legend?.fit || legend._patchedMinWidth) return;
      legend._patchedMinWidth = true;
      const originalFit = legend.fit.bind(legend);
      legend.fit = function () {
        originalFit();
        const ctx = document.createElement('canvas').getContext('2d');
        ctx.font = '400 18px sans-serif';
        const titleWidth = ctx.measureText(title).width + 32;
        this.width = Math.max(this.width, titleWidth);
      };
    }
  };

  const padLabelsToEqualWidth = (items) => {
    const ctx = document.createElement('canvas').getContext('2d');
    ctx.font = '400 16px sans-serif';
    const spaceWidth = ctx.measureText(' ').width;
    const referenceWidth = ctx.measureText('Windows').width;
    return items.map((item) => {
      const diff = Math.max(0, referenceWidth - ctx.measureText(item[0]).width);
      const spaces = Math.ceil(diff / spaceWidth) + 3;
      return item[0] + ' '.repeat(spaces);
    });
  };

  const labels = padLabelsToEqualWidth(data);
  const counts = data.map((item) => item[1]);
  const chartData = {
    labels,
    datasets: [
      {
        label: 'Scans',
        data: counts,
        backgroundColor: isMePage
          ? colorSetsMePage[color] || colorSets.device
          : isGenQrCodePage 
          ? colorSetsGenQrCode[color]
          : colorSets[color] || colorSets.device,
        borderColor: '#FFFFFF',
        borderWidth: 1
      }
    ]
  };
  return (
    <PieWrapper className="mx-auto w-100">
      <Pie data={chartData} options={options} plugins={[legendMinWidthPlugin]} />
    </PieWrapper>
  );
};

export default DeviceChart;

const PieWrapper = styled.div`
  aspect-ratio: 1 / 1;
  max-width: 350px !important;
  @media (min-width: 992px) {
    max-width: 400px !important;
  }
`;
